import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserRoomEventType, UserRoomMessage } from '@jms/model';
import { ApplicationActions } from '@jms/tenant/module.jms.state';
import { AuthTokenService } from '@jms/utils/util.authentication';
import { UserRoomSocketService } from '@workbuddy/services';

@Injectable({ providedIn: 'root' })
export class AuthSessionSocketService {

  private readonly actions = inject(ApplicationActions);
  private readonly authTokenService = inject(AuthTokenService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly userRoom = inject(UserRoomSocketService);

  constructor() {

    this.userRoom.events$
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(event => this.handleUserRoomEvent(event));
  }

  private handleUserRoomEvent(event: UserRoomMessage): void {

    if (event.type !== UserRoomEventType.AuthSessionRevoked) {
      return;
    }

    // Ignore the echo of our own logout — otherwise the second dispatch navigates the
    // page and cancels the in-flight logout request before its response is read.
    if (this.authTokenService.isLoggingOut()) {
      return;
    }

    const revokedSessionId = event.payload.sessionId;

    // No sessionId means every session for this user was revoked (account disabled, maintenance) — log out unconditionally.
    if (!revokedSessionId) {
      this.actions.logout(true);
      return;
    }

    const sessionId = this.authTokenService.getSessionId();

    // Only react to revocations of our own, known session (e.g. another device/admin).
    if (sessionId && sessionId === revokedSessionId) {
      this.actions.logout(true);
    }
  }
}
